export var getTitleTypographyProps = function getTitleTypographyProps(layoutType) {
  switch (layoutType) {
    case 'tablet':
    case 'mobile':
      return {
        purpose: 'headline',
        size: 'l'
      };
    case 'desktop':
    case 'desktopSmall':
    default:
      return {
        purpose: 'display',
        size: 'm'
      };
  }
};